var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwnerOccupied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1249 18.0785H17.9904H4.97432V1.95891H20.0861V21.1294C20.0861 21.3685 19.987 21.6073 19.795 21.7905C19.6023 21.9745 19.3322 22.0854 19.0416 22.0863C18.8209 22.0843 18.5955 21.99 18.4183 21.8002C18.2387 21.6078 18.1268 21.3345 18.1249 21.0365V18.0785ZM3.06057 0.045166V18.0785H0.0546989L0.0546875 21.0392L0.0547099 21.0439C0.0584083 21.8064 0.342316 22.5485 0.863 23.1062C1.3857 23.666 2.10796 23.9958 2.87723 24H19.0382C19.8094 23.9998 20.5582 23.7077 21.1165 23.1748C21.6765 22.6402 21.9998 21.9055 21.9998 21.1294V0.045166H3.06057ZM1.96844 19.9922H3.06057H16.0766V21.1294C16.0766 21.46 16.1353 21.783 16.2459 22.0863H2.88573C2.66484 22.0845 2.43919 21.9901 2.26183 21.8002C2.08227 21.6079 1.97038 21.3346 1.96844 21.0366V19.9922ZM7.02334 5.96674H18.0371V4.053H7.02334V5.96674ZM18.0371 9.97458H7.02334V8.06083H18.0371V9.97458ZM7.02334 13.9824H16.0331V12.0687H7.02334V13.9824Z",
    fill: "#55489E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerOccupied);
export default __webpack_public_path__ + "static/media/owner-occupied.d60cfa82.svg";
export { ForwardRef as ReactComponent };